import UserList from "./Components/UserList";
import AddUser from "./Components/AddUser";

export default {
  name: "Users",
  namespace: "user",
  description: "Components to manage users",

  /**
   * Install parts of this package into vue.
   * @param Vue
   */
  install: Vue => {
    Vue.component(UserList.name, UserList);
    Vue.component(AddUser.name, AddUser);
  },

  /**
   * Initialize this package against the kernel
   * @param {Kernel} kernel
   */
  init: kernel => {
    return kernel === kernel;
  },

  /**
   * An array of package namespaces that this package requires to be loaded and included first.
   */
  requires: []
};
